module.exports = __webpack_public_path__ + "static/media/performing-arts.3d843600.jpg";